import type { ReactNode } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "@/widgets/header";
import { Container } from "@/shared/ui";

export interface RootLayoutProps {
  children?: ReactNode;
}

export const RootLayout = ({ children }: RootLayoutProps) => {
  const location = useLocation();
  const isLoginPage = location.pathname === "/login" || location.pathname === "/auth/callback";

  return (
    <div className="min-h-screen flex flex-col bg-neutral-100">
      {/* Header Widget */}
      {!isLoginPage && <Header />}

      {/* 800px Main Workspace Area with subtle page transition */}
      <main className="flex-1 py-8">
        <Container>
          <div key={location.pathname} className="animate-page-in">
            {children ?? <Outlet />}
          </div>
        </Container>
      </main>

      {/* Footer / Status Bar */}
      <footer className="py-6 text-neutral-500 text-xs">
        <Container className="flex flex-col sm:flex-row items-center justify-between gap-3">
          <span>
            &copy; {new Date().getFullYear()} Kizi. ResultPro Workspace
          </span>
          <div className="flex items-center gap-4">
            <span className="hover:text-neutral-400 transition-colors cursor-pointer">
              Документация
            </span>
            <span className="hover:text-neutral-400 transition-colors cursor-pointer">
              Поддержка
            </span>
          </div>
        </Container>
      </footer>
    </div>
  );
};
